import React, { useEffect, useState, lazy, Suspense } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SplashScreen from './components/SplashScreen';
const Navbar = lazy(() => import('./components/Navbar'));
const Hero = lazy(() => import('./components/Hero'));
const Stats = lazy(() => import('./components/Stats'));
const Products = lazy(() => import('./components/Products'));
const WhyUs = lazy(() => import('./components/WhyUs'));
const Industries = lazy(() => import('./components/Industries'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
import './App.css';

/* ══════════════════════════════════════
   FLOATING ACTION BUTTONS (no overlap)
══════════════════════════════════════ */
const FloatingButtons = () => {
  const [waHovered, setWaHovered] = useState(false);
  const [phHovered, setPhHovered] = useState(false);

  return (
    /* Stack from bottom: phone first, then WhatsApp above */
    <div className="fixed bottom-6 right-5 z-50 flex flex-col-reverse gap-3 items-end">

      {/* ── WhatsApp ── */}
      <a
        id="float-whatsapp-btn"
        href="https://wa.me/918307434329?text=Hello%20SteamX%20Systems%2C%20I%20need%20a%20boiler%20quote."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        onMouseEnter={() => setWaHovered(true)}
        onMouseLeave={() => setWaHovered(false)}
        className="flex items-center gap-0 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl shadow-green-500/40 transition-all duration-300 hover:shadow-green-500/60 overflow-hidden h-14"
        style={{ width: waHovered ? 'auto' : '56px' }}
      >
        {/* Icon */}
        <div className="w-14 h-14 flex items-center justify-center flex-shrink-0">
          <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </div>
        {/* Label — slide in on hover */}
        <AnimatePresence>
          {waHovered && (
            <motion.span
              initial={{ opacity: 0, width: 0 }}
              animate={{ opacity: 1, width: 'auto' }}
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: 0.2 }}
              className="pr-4 text-sm font-bold whitespace-nowrap overflow-hidden"
            >
              WhatsApp Us
            </motion.span>
          )}
        </AnimatePresence>
      </a>

      {/* ── Phone ── */}
      <a
        id="float-phone-btn"
        href="tel:+918307434329"
        aria-label="Call SteamX Systems"
        onMouseEnter={() => setPhHovered(true)}
        onMouseLeave={() => setPhHovered(false)}
        className="flex items-center gap-0 bg-orange-500 hover:bg-orange-600 text-white rounded-full shadow-2xl shadow-orange-500/40 transition-all duration-300 hover:shadow-orange-500/60 overflow-hidden h-14"
        style={{ width: phHovered ? 'auto' : '56px' }}
      >
        <div className="w-14 h-14 flex items-center justify-center flex-shrink-0">
          <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </div>
        <AnimatePresence>
          {phHovered && (
            <motion.span
              initial={{ opacity: 0, width: 0 }}
              animate={{ opacity: 1, width: 'auto' }}
              exit={{ opacity: 0, width: 0 }}
              transition={{ duration: 0.2 }}
              className="pr-4 text-sm font-bold whitespace-nowrap overflow-hidden"
            >
              +91 83074 34329
            </motion.span>
          )}
        </AnimatePresence>
      </a>
    </div>
  );
};

/* ══════════════════════════════════════
   SCROLL TO TOP
══════════════════════════════════════ */
const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const fn = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          id="scroll-to-top-btn"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          /* Positioned above the floating buttons stack (bottom-6 + 14*2 + gap*2 ≈ bottom-36) */
          className="fixed bottom-36 right-5 z-50 w-11 h-11 bg-slate-800/90 hover:bg-orange-500 border border-slate-700 hover:border-orange-500 text-slate-400 hover:text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300 backdrop-blur-sm"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
        >
          ↑
        </motion.button>
      )}
    </AnimatePresence>
  );
};

/* ══════════════════════════════════════
   MAIN APP
══════════════════════════════════════ */
function App() {
  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 2000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      {showSplash && <SplashScreen />}
      <Suspense fallback={<div className="loader">Loading...</div>}>
        <div className="min-h-screen bg-slate-950 text-white">
          <Navbar />
          <main>
            <Hero />
            <Stats />
            <Products />
            <WhyUs />
            <Industries />
            <Contact />
          </main>
          <Footer />
          {/* Floating UI — no overlap: scroll-to-top above, phone + WA stacked at bottom */}
          <FloatingButtons />
          <ScrollToTop />
        </div>
      </Suspense>
    </>
  );
}

export default App;
